import React from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { AuthProvider, useAuth, ProtectedRoute } from "@/components/shared/AuthContext";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { LanguageProvider } from "@/components/shared/i18n";
import LoginPage from "@/components/auth/LoginPage";
import ForgotPasswordPage from "@/components/auth/ForgotPasswordPage";
import ResetPasswordPage from "@/components/auth/ResetPasswordPage";
import FirstPasswordChangePage from "@/components/auth/FirstPasswordChangePage";
import OwnerApp from "@/components/owner/OwnerApp";
import AdminApp from "@/components/admin/AdminApp";
import LegalNotice from "@/components/shared/LegalNotice";
import PrivacyPolicy from "@/components/shared/PrivacyPolicy";
import UnsubscribePage from "@/components/shared/UnsubscribePage";
import { SiteFooter } from "@/components/shared/SiteFooter";

function AppInner() {
  const { me } = useAuth();

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/first-password"
            element={
              me && me.must_change_password ? (
                <FirstPasswordChangePage />
              ) : (
                <Navigate to={me ? (me.role === "admin" ? "/admin" : "/owner") : "/login"} replace />
              )
            }
          />

          {/* Pages publiques — RGPD / Mentions légales / Désinscription voyageur */}
          <Route path="/mentions-legales" element={<LegalNotice />} />
          <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />

          <Route
            path="/owner"
            element={
              <ProtectedRoute role="owner">
                <OwnerApp />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminApp />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              me ? (
                <Navigate to={me.role === "admin" ? "/admin" : "/owner"} replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <SiteFooter />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <ErrorBoundary>
            <AppInner />
          </ErrorBoundary>
        </AuthProvider>
        <Toaster />
      </LanguageProvider>
    </BrowserRouter>
  );
}
